import { Directive, HostListener } from "@angular/core";
import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { Controller } from "@commoncore/controller/Controller";
import { AllFilesImplementation } from "@commoncore/implementation/AllFilesImplementation";
import { HomePageImplementation } from "@commoncore/implementation/HomePageImplementation";
import { DcgroupcodePickerService } from "@commoncore/services/dcgroupcode-picker.service";
import { GlobalService } from "@commoncore/services/global.service";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { ShareAccessImplementation } from "../implementation/ShareAccessImplementation";

@Directive()
export class UnivShareLinkAllFilesController extends Controller{
  public http: any;
  public shareaccessimpl: any;
  public universalService: any;
  public static singleInstance: any = null;
  router: any;
  shareAccessService: any;
  localStorageService: any;
  homePageImplementation: any;

  containerHeightCalc: any;
  allFilesImplementation: AllFilesImplementation;
  dcGroupCodePicker: any;
  sessionStorageService:any;
  @HostListener('window:resize', []) resize() {
    var self = this;
    self.setHeightForView();
  }
  public constructor(private globalService: GlobalService) {
    super(globalService);
    this.shareaccessimpl = ShareAccessImplementation.getInstance(globalService);
    this.allFilesImplementation = AllFilesImplementation.getInstance(globalService);
    this.homePageImplementation = HomePageImplementation.getInstance(globalService);
    this.universalService = globalService.getUniversalServiceRef();
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.setEnvObjects(globalService);
    setTimeout(()=>{
      this.setHeightForView();
    },1000)
   
    
  }

  public static getInstance(connectionService): UnivShareLinkAllFilesController {
    if (this.singleInstance == null) {
      this.singleInstance = new UnivShareLinkAllFilesController(connectionService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  public setEnvObjects(globalService) {
    this.http = globalService.getHttpClientRef();
    this.router = globalService.getRouterRef();
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
  }

  public async getAllFilesAndFolders() { 
    this.allFilesImplementation.refetchData = true;
    let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
    var url = ENV_CONFIG.commonUrls["enhancedSharePublicLink"] + '/' + this.shareAccessService.univShareKey + '?limit=' + limit;
    url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url);
    if (this.sessionStorageService.getCurrentFolderkey(true)) {
      url = url + '&folderKey=' + this.sessionStorageService.getCurrentFolderkey(true);
    }
    try {
      await this.allFilesImplementation.getAllFilesAndFoldersData(url);
      // AppEvents.emit(EventsList.MYFILES_TABBED_VIEW);
    } catch (exc) {
      console.log("exception in all files api",exc);
    }
  }


  openFolder(folder) {
    var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
    collapsedHeight = collapsedHeight ? collapsedHeight : 0
    const result = this.allFilesImplementation.openFolder(folder);
    this.universalService.viewIsTabOriented = true;
    this.universalService.emptyTabViewRequiresMenu = true;
    if (result) {
      setTimeout(() => {
        if (!this.universalService.isMobileDevice) { 
          if(this.universalService.listView){
            this.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],69)
          }else{
            if(this.universalService.virtualGridEnabled) return
            this.containerHeightCalc.calculateHeight('.allFilesScrollableContainer',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],53);
          }
        } else {
          if(this.universalService.virtualGridEnabled) return
          this.containerHeightCalc.calculateHeight('.allFilesScrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container'],60+collapsedHeight);
        }
      }, 1500);
    }

  }

  async openFolderContent(folder) { 
    this.universalService.foldersArray = [];
    this.universalService.sortByDateArray = [];
    this.universalService.sortByNameArray = [];
    var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
    collapsedHeight = collapsedHeight ? collapsedHeight : 0;
    let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
    var url = ENV_CONFIG.commonUrls["enhancedSharePublicLink"] + '/' + this.shareAccessService.univShareKey;
    var summaryUrl = ENV_CONFIG.commonUrls["univShareSummary"] + '/' + this.shareAccessService.univShareKey;
    url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url);
    summaryUrl = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(summaryUrl);
    try {
      if (folder && folder.objectKey) {
        url = url + '?folderKey=' + folder.objectKey + "&limit=" + limit;
        summaryUrl = summaryUrl + '?f=' + folder.objectKey;
        this.shareAccessService.currentOpenFolderName = folder["objectName"];
      }
      // try{
      //   let result = await this.homePageImplementation.shareFetchSummary(summaryUrl, true);
      // }catch(ex){
      //   console.log("exception - " + ex);
      // }
      if (folder && folder.objectKey) {
        this.allFilesImplementation.getAllFilesAndFoldersData(url);
      }
      else {
        this.shareAccessService.currentOpenFolderName = "";
        this.getAllFilesAndFolders();
      }
    }
    catch (err) {
      console.log("share link open folder Error - " + err);
    }
    setTimeout(() => {
      if (!this.universalService.isMobileDevice) {
        if(this.universalService.listView){
          this.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],40)
        }else{
          if(this.universalService.virtualGridEnabled) return
          this.containerHeightCalc.calculateHeight('.allFilesScrollableContainer',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],29);
        }
      } else {
        if(this.universalService.virtualGridEnabled) return
        this.containerHeightCalc.calculateHeight('.allFilesScrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container'],60+collapsedHeight);
      }
    }, 1500);
  }

  openPublicSort(sortType,reverseOrder) {
    this.universalService.disableModalBackdrop();
    let sortTypeName = this.universalService.togglePublicSort(sortType,reverseOrder);
    if(sortTypeName!=""){
          this.sessionStorageService.setSharePublicSortPropName(sortTypeName);
    }
    this.allFilesImplementation.allFilespreviousLink = "";
    this.universalService.isMobileTopMoreOptionMenu = false;
    this.switchView();
  }

  switchView(){
    this.universalService.sortByDateArray = [];
    this.universalService.sortByNameArray = [];
    this.universalService.foldersArray = [];
    this.getAllFilesAndFolders();
  }

  setHeightForView() {
    var self = this;
    self.setHeightForContainer();
    $(window).resize(function () {
      self.setHeightForContainer();
    });
  }

  setHeightForContainer(){
    if(this.universalService.virtualGridEnabled) return;
    var self = this;
    var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
    collapsedHeight = collapsedHeight ? collapsedHeight : 0
    if (!self.universalService.isMobileDevice && !self.universalService.openFolderContent) {
      setTimeout(() => {
        if(this.universalService.virtualGridEnabled) return
        if(this.universalService.listView){
          this.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],69)
        } else {
          this.containerHeightCalc.calculateHeight('.allFilesScrollableContainer', ['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'], 79)
        }
      }, 300);
    }else if(!self.universalService.isMobileDevice && self.universalService.openFolderContent){
      setTimeout(() => {
        if(this.universalService.virtualGridEnabled) return
        this.containerHeightCalc.calculateHeight('.allFilesScrollableContainer', ['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'], 29)
      }, 200);
    }

    if (self.universalService.isMobileDevice) {
      setTimeout(() => {
        this.containerHeightCalc.calculateHeight('.allFilesScrollableContainer', ['.pseudo-mobile-header', '.pseudo-tab','.pseudo-banner-container'], (65 + collapsedHeight))
      }, 200);
    }
  }

  onListScrollDown() { // this will get called when user is inside folder in list view only
    this.allFilesImplementation.allFilesnextLink  = this.universalService.allFilesnextLink
    var url = "";
    url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + this.allFilesImplementation.allFilesnextLink;
    try {
      this.allFilesImplementation.createUrlForNextLinkOnDesktop(url);
    }
    catch (exc) {
      //this.loggerService.log("exception in scroll down")
    }
  }

  decideScrollCall(){
      this.onListScrollDown();
  }

  selectAll(event){
    this.allFilesImplementation.selectAll(event)
  }

  onScrollDown(docheignt, toppos,containerName) {
    if(this.universalService.listView && !this.universalService.isMobileDevice){
        return
    }
    this.allFilesImplementation.allFilesnextLink  = this.universalService.allFilesnextLink
    var url = "";
    url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + this.allFilesImplementation.allFilesnextLink;
    try {
      this.allFilesImplementation.createUrlForNextLink(docheignt, toppos, url,containerName);
    }
    catch (exc) {
      console.log("exception in scroll down",exc);
    }
  }
}